export default {
  close: 'סגור',
  dataIterator: {
    pageText: '{0}-{1} מתוך {2}',
    noResultsText: 'לא נמצאו תוצאות מתאימות',
    loadingText: 'טוען פריט...',
  },
  dataTable: {
    itemsPerPageText: 'שורות לעמוד:',
    ariaLabel: {
      sortDescending: ': ממוין לפי סדר עולה. לחץ להספקת המיון.',
      sortAscending: ': ממוין לפי סדר יורד. לחץ למיון לפי סדר עולה.',
      sortNone: ': לא ממוין. לחץ למיון לפי סדר עולה.',
    },
    sortBy: 'סדר לפי',
  },
  dataFooter: {
    itemsPerPageText: 'פריטים לדף:',
    itemsPerPageAll: 'הכל',
    nextPage: 'עמוד הבא',
    prevPage: 'עמוד הקודם',
    firstPage: 'עמוד ראשון',
    lastPage: 'עמוד אחרון',
  },
  datePicker: {
    itemsSelected: '{0} נבחרו',
  },
  noDataText: 'אין נתונים זמינים',
  carousel: {
    prev: 'מצג קודם',
    next: 'מצג הבא',
  },
  calendar: {
    moreEvents: '{0} נוספים',
  },
  fileInput: {
    counter: '{0} קבצים',
    counterSize: '{0} קבצים ({1} בסך הכל)',
  },
}
